import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { combineLatest, forkJoin, Observable } from "rxjs";
import { map } from "rxjs/operators";

export class CustomTranslateLoader implements TranslateLoader{
    private http: HttpClient;
    constructor(http: HttpClient) {            
        this.http = http;
    }
    getTranslation(lang: string): Observable<any> {
        const data:Observable<any>[] = [];
        data.push(this.http.get("assets/i18n" + "/" + lang + ".json"));
        data.push(this.http.get("assets/i18n" + "/" + lang + "-customer.json"));
        let languageObservables = forkJoin(data);
        return languageObservables.pipe(map(([a, b]) => {
             return Object.assign({},a,b);
        }));       
    }

}